import FAQContent from './FAQContent';
export default FAQContent;